import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Button from '../../components/Button';

import './error-page.scss';

export default function ErrorPage() {
  let history = useHistory();
  const { error } = useSelector(({ error }) => ({
    error: error.errorMessage,
  }));
  return (
    <section className='error-page-container'>
      <div className='error-page-logo'>
        <img src={require('./../../img/logo-patagonia-blanco.svg')} alt='' />
      </div>
      <div className='error-page-modal'>
        <div className='error-page-text-container'>
          <span>{error.message || 'Ha ocurrido un error'}</span>
        </div>
        <hr />
         <Button color='secondary' onClick={() => history.push('/')}>
           {error.cta || 'Continuar'}
          </Button>
      </div>
    </section>
  );
}
